module.exports = __webpack_public_path__ + "newsdefault4.jpg?b7dbe91e54e136b18e60c519e9c6a161";